import { Component, Input } from '@angular/core';
import { formattedAmount } from '../../../helpers/format-currency';

@Component({
  selector: 'app-base-currency',
  templateUrl: './base-currency.component.html',
  styleUrls: ['./base-currency.component.scss'],
})
export class BaseCurrencyComponent {
  @Input() amount: number;
  @Input() currency = '€';
  @Input() start: string;
  @Input() end: string;
  @Input() text: string;

  public get formattedAmount(): string {
    return formattedAmount(this.amount);
  }
}
